import { render, staticRenderFns } from "./Tradutor.vue?vue&type=template&id=71201854"
import script from "./Tradutor.vue?vue&type=script&lang=js"
export * from "./Tradutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports